import { useRef, useEffect, useState } from 'react';
import style from './Sec05.module.css';
import img01 from '../images/sec05_img01.png'
import img02 from '../images/sec05_img02.png'
import img03 from '../images/sec05_img03.png'
import img04 from '../images/sec05_img04.png'
import img05 from '../images/sec05_img05.png'
import img06 from '../images/sec05_img06.png'
import img07 from '../images/sec05_img07.png'
import img08 from '../images/sec05_img08.png'
import img09 from '../images/sec05_img09.png'
import img10 from '../images/sec05_img10.png'
import img11 from '../images/sec05_img11.png'
import img12 from '../images/sec05_img12.png'
import img13 from '../images/sec05_img13.png'
import img14 from '../images/sec05_img14.png'
import img15 from '../images/sec05_img15.png'
import img16 from '../images/sec05_img16.png'
import img17 from '../images/sec05_img17.png'
import img18 from '../images/sec05_img18.png'
import img19 from '../images/sec05_img19.png'
import img20 from '../images/sec05_img20.png'
import img21 from '../images/sec05_img21.png'
import img22 from '../images/sec05_img22.png'
import img23 from '../images/sec05_img23.png'
import img24 from '../images/sec05_img24.png'
import img25 from '../images/sec05_img25.png'

function Sec05() {

    const imgList01 = [
        { src: img01, alt: '아암레드' },
        { src: img02, alt: '선인장'},
        { src: img03, alt: 'KAYA' },
        { src: img04, alt: '밀크폼' },
        { src: img05, alt: '맥스쿨 모드' },
        { src: img06, alt: '맥스쿨' },
        { src: img07, alt: '얼려먹구싶오' },
        { src: img08, alt: '심쿵' },
        { src: img09, alt: '심쿵플러스'},
        { src: img10, alt: 'MFS' },
        { src: img11, alt: 'dessert' },
        { src: img12, alt: 'AME' },
    ];

    const imgList02 = [
        { src: img13, alt: '지니어스' },
        { src: img14, alt: '과일먹구싶오'},
        { src: img15, alt: '깔끔' },
        { src: img16, alt: '로망' },
        { src: img17, alt: '스노우맨' },
        { src: img18, alt: '스노우맨꽁꽁' },
        { src: img19, alt: 'MOV' },
        { src: img20, alt: '네이플 디저트' },
        { src: img21, alt: '버몬트' },
        { src: img22, alt: '버몬트 모드' },
        { src: img23, alt: '이프로 생각날때' },
        { src: img24, alt: '톡톡' },
        { src: img25, alt: '스파클링' },
    ];

    return (
        <div className={style.wrap}>
            <div className={style.tit_box}>
                <h4>
                    검증된 기술력<br />
                    믿고 쓰는 푸푸케미칼 자사제품
                </h4>
            </div>
            <div className={style.slider_wrap}>
                <div className={style.slider_track}>
                    <div className={style.slide}>
                        {[...imgList01, ...imgList01].map((item, idx) => (
                            <img key={idx} src={item.src} alt={item.alt} />
                        ))}
                    </div>
                </div>
                <div className={`${style.slider_track} ${style.slider_track02}`}>
                    <div className={style.slide}>
                        {[...imgList02, ...imgList02].map((item, idx) => (
                            <img key={idx} src={item.src} alt={item.alt} />
                        ))}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Sec05;